'use strict';

var _isPlainObj = require('is-plain-obj');

var _isPlainObj2 = _interopRequireDefault(_isPlainObj);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a reducer function that always returns an Immutable.Map
 * @param {Object|Immutable.Map} reducers - keys or entries of functions
 * @return {Function} - a reducer function
 */
module.exports = function (reducers) {
  if ((0, _isPlainObj2.default)(reducers)) {
    Object.keys(reducers).forEach(function (key) {
      if (typeof reducers[key] !== 'function') {
        throw new Error('Expected an object with all keys being functions');
      }
    });

    return function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
      var action = arguments[1];
      return Object.keys(reducers).reduce(function (nextstate, key) {
        return nextstate.set(key, reducers[key](state.get(key), action));
      }, state);
    };
  }

  if (_immutable.Map.isMap(reducers)) {
    reducers.keySeq().forEach(function (key) {
      if (typeof reducers.get(key) !== 'function') {
        throw new Error('Expected an Immutable.Map with all entries being functions');
      }
    });

    return function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.Map)({}) : arguments[0];
      var action = arguments[1];
      return reducers.keySeq().reduce(function (nextstate, key) {
        return nextstate.set(key, reducers.get(key)(state.get(key), action));
      }, state);
    };
  }

  throw new TypeError('Expected an object or Immutable Map');
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-immutable-combine-reducers/lib/index.js
// module id = 211
// module chunks = 0